import { SpringValue } from "react-spring";
import * as React from "react";
import styled, { css } from "styled-components";
import { mapConfig } from "../../utils/map-utils/map-config";
import { LoadingContext } from "../../contexts/LoadingContent";

interface ZoomButtonsProps {
  onZoom: (amount: number) => void;
  currentScale: SpringValue<number>;
}

const ZoomButtons: React.FC<ZoomButtonsProps> = (props) => {
  const [{ isCartoucheComplete }] = React.useContext(LoadingContext);

  const zoomIn = React.useCallback(() => {
    const currentScale = props.currentScale.getValue();
    props.onZoom(mapConfig.zoom.max / currentScale);
  }, [props]);

  const zoomOut = React.useCallback(() => {
    const currentScale = props.currentScale.getValue();
    props.onZoom(-(currentScale / mapConfig.zoom.min));
  }, [props]);

  return (
    <Wrapper className={isCartoucheComplete ? "active" : "hidden"}>
      <Zoom className="zoom-in" onClick={() => zoomIn()}>
        +
      </Zoom>
      <Zoom className="zoom-out" onClick={() => zoomOut()}>
        -
      </Zoom>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  display: flex;
  transform: translateX(100px);
  opacity: 0;
  transition: all ease-in-out 0.3s;
  &.active {
    opacity: 1;
    transform: translateX(0px);
  }

  @media (max-width: 960px) {
    right: 1rem;
    bottom: 1rem;
  }
  border-radius: 20px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
const Zoom = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    background: white;
    color: ${theme.colors.accent};
    transition: all ease-in-out 0.2s;

    &:hover,
    &:focus {
      background: ${theme.colors.accent};
      color: white;
    }
    user-select: none;
    cursor: pointer;
    font-size: 2rem;
    font-weight: bold;
    padding: 0.5rem 0.75rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:first-child {
      border-bottom: 2px solid ${theme.colors.lightGrey};
    }
    &.zoom-out {
      padding-top: 0.2rem;
    }
  `}
`;

export default ZoomButtons;
